class QuickATC extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelectorAll('[data-quick-buy-btn]');
    this.cartItems = document.querySelector('cart-items');

    this.bundleBtns = this.querySelectorAll('.update-bundle');
    this.bundlePrices = this.querySelectorAll('.recipe-bundle__price');
    this.cardWidth = this.querySelector('.swiper-slide.buly-card-product').offsetWidth - 20;

    if (!this.button) {
      return;
    }

    this.button.forEach(
      (btn) => {
        btn.addEventListener('click', this.onClickHandler.bind(this));
      }
    );

    if (this.bundleBtns.length > 0) {
      this.bundleBtns.forEach(
        (btn) => {
          btn.addEventListener('click', this.updateBundle.bind(this));
          btn.style.top = this.cardWidth - 50 + 'px';
        }
      );
      this.checkBtnReq();
    }

    if (this.bundleBtns.length > 0) {
      window.addEventListener("resize", () => {
        this.cardWidth = this.querySelector('.swiper-slide.buly-card-product').offsetWidth - 20;
        this.bundleBtns.forEach(
          (btn) => {
            btn.addEventListener('click', this.updateBundle.bind(this));
            btn.style.top = this.cardWidth + 'px';
          }
        );
      });
    }
  }

  checkBtnReq() {
    if (this.getAttribute('variant-ids') == '') {
      this.button.forEach(
        (btn) => {
          btn.setAttribute('disabled', true);
        }
      );
    } else {
      this.button.forEach(
        (btn) => {
          btn.removeAttribute('disabled');
        }
      );
    }
  }

  updateBundle(event) {
    const eventButton = event.target.closest('.update-bundle');
    const varId = eventButton.getAttribute('data-variant-id');
    const varPrice = eventButton.getAttribute('data-price');
    const bundlePrice = this.querySelector('.recipe-bundle__price').getAttribute('data-bundle-price');

    if (eventButton.classList.contains('add-to-bundle')) {
      if (this.getAttribute('variant-ids') == '') {
        this.setAttribute('variant-ids', varId);
        this.bundlePrices.forEach(
          (price) => {
            price.setAttribute('data-bundle-price', varPrice);
            price.innerHTML = varPrice / 100 + ' €';
          }
        );
        eventButton.classList.remove('add-to-bundle');
        eventButton.classList.add('remove-from-bundle');
      } else {
        this.setAttribute('variant-ids', this.getAttribute('variant-ids') + ',' + varId);
        const newBundlePrice = (bundlePrice * 1) + (varPrice * 1);
        this.bundlePrices.forEach(
          (price) => {
            price.setAttribute('data-bundle-price', newBundlePrice);
            price.innerHTML = newBundlePrice / 100 + ' €';
          }
        );
        eventButton.classList.remove('add-to-bundle');
        eventButton.classList.add('remove-from-bundle');
      }
    } else {
      if (varPrice == bundlePrice) {
        this.setAttribute('variant-ids', '');
        this.bundlePrices.forEach(
          (price) => {
            price.setAttribute('data-bundle-price', '');
            price.innerHTML = '0 €';
          }
        );
        eventButton.classList.remove('remove-from-bundle');
        eventButton.classList.add('add-to-bundle');
      } else {
        if (this.getAttribute('variant-ids').includes(varId + ',')) {
          const newVars = this.getAttribute('variant-ids').replace(varId + ',', '');
          this.setAttribute('variant-ids', newVars);
        } else {
          const newVars = this.getAttribute('variant-ids').replace(',' + varId, '');
          this.setAttribute('variant-ids', newVars);
        }
        const newBundlePrice = (bundlePrice * 1) - (varPrice * 1);
        this.bundlePrices.forEach(
          (price) => {
            price.setAttribute('data-bundle-price', newBundlePrice);
            price.innerHTML = newBundlePrice / 100 + ' €';
          }
        );
        eventButton.classList.remove('remove-from-bundle');
        eventButton.classList.add('add-to-bundle');
      }
    }
    this.checkBtnReq();
  }

  onClickHandler(event) {
    event.preventDefault();

    this.variantIds = this.getAttribute('variant-ids');
    this.properties = this.getAttribute('line-item-props');
    this.fade = !!this.getAttribute('fade');

    if (!this.variantIds) {
      return;
    }

    this.button.forEach(
      (btn) => {
        btn.setAttribute('disabled', true);
        btn.classList.add('loading');
      }
    );

    if (this.fade) {
      this.classList.add('animate__animated', 'animate__fadeOut', 'animate__faster');
    }

    const quantityEl = this.querySelector('input[name="quantity"]');
    const quantity = quantityEl ? parseInt(quantityEl.value) : 1;

    let properties;
    if (this.properties) {
      try {
        properties = JSON.parse(this.properties);
      } catch (err) {
        console.error(err);
      }
    }

    let itemsArr = [];
    const varIdsArr = this.variantIds.split(',');
    varIdsArr.forEach(varId => {
      itemsArr.push({
        id: varId,
        quantity: quantity,
        properties: properties
      });
    });

    let body = {
      items: itemsArr
    };

    if (this.cartItems) {
      body.sections = this.cartItems.getSectionsToRender().map(section => section.id);
      body.sections_url = window.location.pathname;
    }

    body = JSON.stringify(body);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(parsedState => {

        if (!parsedState.items && parsedState.message) {
          return this.dispatchEvent(
            new CustomEvent(
              'fostr-quick-buy-done',
              { bubbles: true, detail: { status: 'error', info: parsedState } }
            )
          );
        }

        this.dispatchEvent(
          new CustomEvent(
            'fostr-quick-buy-done',
            { bubbles: true, detail: { status: 'success' } }
          )
        );

        let fadeClass = '';
        if (this.fade) {
          varIdsArr.forEach((id, index) => {
            if (fadeClass === '') {
              fadeClass += `.variant-id-${id}`;
            } else {
              fadeClass += `, .variant-id-${id}`;
            }
          });
        }
        this.cartItems?.renderContents(parsedState, fadeClass);
        return this.cartItems?.checkGifts();
      })
      .catch(error => {
        this.dispatchEvent(
          new CustomEvent(
            'fostr-quick-buy-done',
            { bubbles: true, detail: { status: 'error', error: error } }
          )
        );
        console.error(error);
      })
      .finally(() => {
        this.button.forEach(
          (btn) => {
            btn.classList.remove('loading');
            btn.removeAttribute('disabled');
          }
        );

        document.querySelector('body').classList.remove('quick-buy-open');
        let cardWrapper = document.getElementsByClassName("card-wrapper");
        for (let i = 0; i < cardWrapper.length; i++) {
          cardWrapper[i].classList.remove('active');
        }
      });
  }
}

customElements.define('quick-buy', QuickATC);
